// extracted by mini-css-extract-plugin
export default {"log":"navbar_log__N0AKY","sign":"navbar_sign__TAILu"};